import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'finance/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('finance/', '')
      .toLowerCase();
  }
}
